export const APPLE_ITUNES_APP_META_NAME = 'apple-itunes-app';
export const PASSLENS_IOS_APP_ID = '6770763909';
export const PASSLENS_APP_STORE_URL = `https://apps.apple.com/app/id${PASSLENS_IOS_APP_ID}`;
export const PASSLENS_APPLE_ITUNES_APP_DEFAULT_ARGUMENT = 'https://passlens.com/app';
export const PASSLENS_APPLE_ITUNES_APP_CONTENT =
  `app-id=${PASSLENS_IOS_APP_ID}, app-argument=${PASSLENS_APPLE_ITUNES_APP_DEFAULT_ARGUMENT}`;

const SMART_APP_BANNER_PRODUCT_PAGES = new Set([
  'app',
  'ios-app',
  'passport-photo-maker',
  'passport-photo-checker',
  '2x2-passport-photo-maker',
  'us-passport-photo-maker',
  '600x600-passport-photo-maker',
]);

const SMART_APP_BANNER_BLOG_SLUGS = new Set([
  'passport-photo-app-guide',
  'passport-photo-maker-online-free',
  'passport-photo-for-online-applications',
  'online-passport-renewal-photo-upload-guide',
]);

function normalizeBannerPathname(pathname?: string): string {
  if (!pathname || pathname === '/index.html') return '/app';
  const clean = pathname.split(/[?#]/, 1)[0] || '/app';
  if (clean.length > 1 && clean.endsWith('/')) return clean.slice(0, -1);
  return clean;
}

export function shouldExposeAppleSmartAppBanner(route: { page: string; baseSlug?: string }): boolean {
  if (SMART_APP_BANNER_PRODUCT_PAGES.has(route.page)) return true;
  return route.page === 'blog-post' && Boolean(route.baseSlug && SMART_APP_BANNER_BLOG_SLUGS.has(route.baseSlug));
}

export function getAppleSmartAppBannerContent(pathname?: string): string {
  const argument = `https://passlens.com${normalizeBannerPathname(pathname)}`;
  return `app-id=${PASSLENS_IOS_APP_ID}, app-argument=${argument}`;
}
